import { Box, Container, Grid } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import TeachersSupervision from "./teachers-supervision";

const TeachersSupervisionRoutes = () => {
    return (
        <Box
            component="main"
            flexGrow={1}
            minHeight="100vh"
            overflow="auto"
        >
            <Container
                maxWidth="lg"
                sx={{
                    paddingTop: 4,
                    paddingBottom: 4,
                    paddingRight: 3,
                    paddingLeft: 3,
                }}
            >
                <Grid container spacing={3}>
                    <Routes>
                        <Route index element={<TeachersSupervision />} />
                    </Routes>
                </Grid>
            </Container>
        </Box>
    );
};

export default TeachersSupervisionRoutes;
